module.exports = __webpack_public_path__ + "img/img1.b5e5addb.png";